import { createApi } from '@reduxjs/toolkit/query/react';

import type {
  GetNetworkTokensResponseSchemaType,
  GetNetworksResponseSchemaType,
  NetworkSchemaType,
  NetworkTokenType,
} from 'src/global/schemas/network.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const networkApi = createApi({
  reducerPath: REDUX_SLICE.NETWORK_API,
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    getNetworks: builder.query<NetworkSchemaType[], unknown>({
      query: () => ({
        method: 'GET',
        path: '/v1/networks?filter={"version":3}',
      }),
      transformResponse: (returnValue: GetNetworksResponseSchemaType) => returnValue.data,
    }),
    getNetworkTokens: builder.query<NetworkTokenType[], { networkId: string }>({
      query: ({ networkId }) => ({
        method: 'GET',
        path: `/v1/networks/${networkId}/tokens?filter={"isStable":true}`,
      }),
      transformResponse: (returnValue: GetNetworkTokensResponseSchemaType) => returnValue.data,
    }),
  }),
});

export const { useGetNetworksQuery, useGetNetworkTokensQuery } = networkApi;
